"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withOpenState = void 0;
const decorators_js_1 = require("lit/decorators.js");
/**
 * 열고 닫히는 표면(sheet·dialog·popover·toast·sidebar)이 공유하는 공개 API.
 * 열림 상태는 reflect되는 open 속성 하나로 나타내고, 네이티브 dialog·popover처럼 show·close·toggle 메서드를 함께 둔다.
 * 열고 닫을 때 할 일이 있는 표면(toast의 자동 닫힘 타이머 등)은 메서드를 덮어쓰고 super를 부른다.
 * toggle은 open을 직접 바꾸지 않고 show·close를 거쳐, 덮어쓴 동작이 토글에서도 그대로 실행되게 한다.
 */
const withOpenState = (Base) => {
    class OpenStateElement extends Base {
        constructor() {
            super(...arguments);
            this.open = false;
        }
        show() {
            this.open = true;
        }
        close() {
            this.open = false;
        }
        toggle() {
            if (this.open) {
                this.close();
                return;
            }
            this.show();
        }
    }
    __decorate([
        (0, decorators_js_1.property)({ type: Boolean, reflect: true })
    ], OpenStateElement.prototype, "open", void 0);
    return OpenStateElement;
};
exports.withOpenState = withOpenState;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3Blbi1zdGF0ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm9wZW4tc3RhdGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQ0EscURBQTRDO0FBVzVDOzs7OztHQUtHO0FBQ0ksTUFBTSxhQUFhLEdBQUcsQ0FBb0MsSUFBTyxFQUFFLEVBQUU7SUFDMUUsTUFBTSxnQkFBaUIsU0FBUSxJQUFJO1FBQW5DOztZQUM4QyxTQUFJLEdBQUcsS0FBSyxDQUFBO1FBa0IxRCxDQUFDO1FBaEJDLElBQUk7WUFDRixJQUFJLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQTtRQUNsQixDQUFDO1FBRUQsS0FBSztZQUNILElBQUksQ0FBQyxJQUFJLEdBQUcsS0FBSyxDQUFBO1FBQ25CLENBQUM7UUFFRCxNQUFNO1lBQ0osSUFBSSxJQUFJLENBQUMsSUFBSSxFQUFFO2dCQUNiLElBQUksQ0FBQyxLQUFLLEVBQUUsQ0FBQTtnQkFDWixPQUFNO2FBQ1A7WUFFRCxJQUFJLENBQUMsSUFBSSxFQUFFLENBQUE7UUFDYixDQUFDO0tBQ0Y7SUFsQjZDO1FBQTNDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDO2tEQUFhO0lBb0IxRCxPQUFPLGdCQUE4QyxDQUFBO0FBQ3ZELENBQUMsQ0FBQTtBQXZCWSxRQUFBLGFBQWEsaUJBdUJ6QiJ9